import { Box } from "@mui/material";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { useDispatch } from "react-redux";
import { googleSignup } from "src/api_endpoints/UserLoginSignupAPI";
import { googleSignin } from "src/redux/user/userActions";

const GoogleSignup = ({btnText}) => {
  const dispatch = useDispatch();

  const responseGoogle = async (credentialResponse) => {
    // console.log(credentialResponse);
    if (!credentialResponse?.credential) {
      console.error("Google Sign-Up Failed:", credentialResponse);
      return;
    }

    const decoded = jwtDecode(credentialResponse.credential);
    const { name, email, picture } = decoded;
    // console.log("Decoded Google User:", decoded);

    let phone = null;
    let phoneCountryId = null;

    // Fetch phone number using Google People API
    try {
      const res = await fetch(
        "https://people.googleapis.com/v1/people/me?personFields=phoneNumbers",
        {
          headers: {
            Authorization: `Bearer ${credentialResponse.credential}`,
          },
        }
      );
      const data = await res.json();
      // console.log("People API Response:", data);

      if (data.phoneNumbers && data.phoneNumbers.length > 0) {
        const primaryPhone = data.phoneNumbers[0];
        const rawPhone = primaryPhone.value || null;
        const canonicalForm = primaryPhone.canonicalForm || null;

        if (canonicalForm) {
          phoneCountryId = canonicalForm.slice(0, canonicalForm.length - 10);
        }
        phone = rawPhone ? rawPhone.replace(/[^0-9]/g, "").slice(-10) : null;
      }
    } catch (error) {
      console.error("Error fetching phone number:", error);
    }

    // Prepare user data for signup
    const googleData = {
      name,
      email,
      // imageUrl: "new-avatar.jpeg",
      // imageUrl: picture,
      phone,
      phoneCountryId,
    };
    // console.log("Prepared Google Data:", googleData);

    googleSignup(googleData)
      .then((data) => {
        if (data.success) {
          // console.log("Signup successful:", data);
          dispatch(googleSignin(data.userData.email));
        } else {
          console.error("Error during signup:", data);
        }
      })
      .catch((error) => {
        console.error("Signup Error:", error);
      });
  };


  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT}>
      <Box className="google-button-override">
        <GoogleLogin
          onSuccess={responseGoogle}
          onError={() => console.log("Google Login Failed")}
          text={btnText}
          useOneTap={false}
          auto_select={false}
        />
      </Box>
    </GoogleOAuthProvider>
  );
};

export default GoogleSignup;